import axios from "axios";

export const API_BASE_URL = "https://catacraft.zentexus.in/api";

export const SERVER_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, "");

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30s timeout for live server
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;

